import React, { useEffect, useState } from "react";
import { Table, Button, message, Input, Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import api from "../api";
import ProductorModal from "../components/ProductorModal";

const ProductoresPage = () => {
  const [productores, setProductores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedProductor, setSelectedProductor] = useState(null);
  const [searchText, setSearchText] = useState("");

  const getProductores = async () => {
    try {
      setLoading(true);
      const res = await api.get("/productor/");
      setProductores(res.data.data);
    } catch (err) {
      message.error("Error al obtener productores");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProductores();
  }, []);

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
          flexWrap: "wrap",
          gap: "16px",
        }}
      >
        <h2 style={{ fontSize: "20px", fontWeight: 600, margin: 0 }}>Lista de Productores</h2>
        <Space wrap>
          <Input.Search
            placeholder="Buscar por Nombre o Identificación"
            allowClear
            onSearch={(value) => setSearchText(value)}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: "100%", minWidth: "200px", maxWidth: "300px" }}
          />
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setOpen(true)}
          >
            Nuevo Productor
          </Button>
        </Space>
      </div>
      <Table
        dataSource={productores.filter(
          (item) =>
            item.nombre?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.identificacion?.toString().toLowerCase().includes(searchText.toLowerCase())
        )}
        loading={loading}
        rowKey={(record) => record.idproveedores || record.id || record.idproveedor || record.identificacion}
        columns={[
          { title: "Identificación", dataIndex: "identificacion" },
          { title: "Nombre", dataIndex: "nombre" },
          { title: "Correo", dataIndex: "mail" },
          { title: "WhatsApp", dataIndex: "whatsapp" },
          { title: "Observaciones", dataIndex: "observaciones" },
          {
            title: "Acciones",
            render: (_, record) => (
              <Button 
                type="link" 
                onClick={() => {
                  setSelectedProductor(record);
                  setOpen(true);
                }}
              >
                Editar
              </Button>
            )
          }
        ]}
        scroll={{ x: 'max-content' }}
      />

      <ProductorModal
        open={open}
        record={selectedProductor}
        onCancel={() => {
          setOpen(false);
          setSelectedProductor(null);
        }}
        onSuccess={() => {
          setOpen(false);
          setSelectedProductor(null);
          getProductores();
        }}
      />
    </>
  );
};

export default ProductoresPage;
